import { ButtonIcon, useColorScheme } from "@/lib/main";

export default function ColorSchemeToggle() {
  const { toggleColorScheme } = useColorScheme();

  return (
    <ButtonIcon
      ariaLabel={{
        en: "Toggle between light and dark color scheme",
        ar: "تغيير نظام الألوان بين الفاتح والداكن",
      }}
      iconColor="secondary"
      iconName="light-dark"
      onClick={() => toggleColorScheme()}
      title={{ en: "Toggle color scheme", ar: "تغيير نظام الألوان" }}
    />
  );
}
